<template>
  <div class="goods-inventory">
    <second-menu-link-content>
      <template v-slot:header>
        <span>商品库存</span>
      </template>
      <template v-slot:content>
        <div class="goods-inventory-main">
          <div class="form">
            <el-form :model="formData" ref="formData" label-width="75px" :inline="true">
              <el-form-item label="选择仓库：" prop="warehouse">
                <el-select v-model="formData.warehouse" clearable class="white" placeholder="请选择仓库">
                  <el-option
                    v-for="item in warehouse"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品筛选：" prop="number" label-width="75px">
                <el-input
                  class="white"
                  clearable
                  @keyup.enter.native="search"
                  v-model="formData.codeName"
                  placeholder="请输入商品名称/商品编码"
                ></el-input>
              </el-form-item>
              <el-form-item label="库存状态：" prop="replenishment">
                <el-select v-model="formData.replenishment" clearable class="white" placeholder="请选择状态">
                  <el-option
                    v-for="item in replenishmentList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="btn">
              <el-button class="btn-blue" @click="search">筛选</el-button>
              <el-button class="btn-text" type="text" @click="resetForm('formData')">重置筛选条件</el-button>
            </div>
          </div>
          <!-- 表格部分 -->
          <div class="table-img">
            <el-table :data="tableData" v-loading="loading">
              <el-table-column label="商品名称" width="360">
                <template slot-scope="scope">
                  <el-image class="img" fit="contain" :src="scope.row.img" lazy></el-image>
                  <p class="name" :title="scope.row.name">{{ scope.row.name }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="code" label="商品编码"></el-table-column>
              <el-table-column prop="num" label="库存"></el-table-column>
              <el-table-column prop="saleNum" label="可售库存"></el-table-column>
              <el-table-column prop="minSaleNum" label="最低库存"></el-table-column>
            </el-table>
            <!-- 引入页码 -->
            <div class="table_pagination">
              <PaginationModul :total="total" :currentPage="page" @queryChange="updatePage"></PaginationModul>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import { getDBOperationPermission } from "common/js/storage"; // 权限数据接口
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationModul from "base/PaginationTpl";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  data() {
    return {
      operationList: [], // 权限列表数据
      // 页面按钮--商品库存修改
      operationsBtns: {
        roleStorageGoodsUpdate: "ROLE_STORAGE_goods_update"
      },
      warehouse: [], // 仓库数据
      replenishmentList: [
        {
          id: 0,
          name: '库存正常'
        },
        {
          id: 1,
          name: '库存不足'
        }
      ], //库存状态
      formData: {
        codeName: "",
        warehouse: "",
        replenishment: ""
      },
      form: {
        codeName: "",
        warehouse: "",
        replenishment: ""
      },
      id: null,
      tableData: [
        // {
        //   id: 1,
        //   name: '华硕(ASUS) 飞行堡垒6 15本',
        //   img: '图片',
        //   code: '121254',
        //   warehouse: '杭州',
        //   inventory: 200,
        //   vendibilityInventory: 150,
        //   specifications: '白色'
        // }
      ],
      page: 1,
      total: 0,
      loading: true
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationModul
  },
  beforeMount() {
    if (this.$route.params.code) {
      this.formData.codeName = this.$route.params.code;
      this.search();
    } else {
      this.getTableData();
    }
    this.operationList = getDBOperationPermission();
    this.getWarehouse();
  },
  methods: {
    // 获取仓库数据
    getWarehouse() {
      supplier.getSupplierAllWarehouse().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.name = value.name;
            obj.id = value.id;
            arr.push(obj);
          });
          this.warehouse = arr;
        }
      });
    },
    // 获取表格列表数据
    getTableData() {
      let currentPage = this.page;
      let goodsName = this.form.codeName ? this.form.codeName : "";
      let warehouseId = this.form.warehouse;
      let sellOut = this.form.replenishment;
      let options = {
        goodsName,
        currentPage,
        warehouseId,
        sellOut
      }
      supplier
        .getSupplierStockGoods(options)
        .then(res => {
          if (res.success) {
            this.total = res.result.totalNum;
            let arr = [];
            res.result.items.map((value, index, array) => {
              let obj = {};
              obj.id = value.id;
              obj.name = value.goodsName;
              obj.sellout = value.sellout;
              obj.img = value.itemImages[0]
                ? value.itemImages[0]
                : "http://ydbtest.cnpu.com/img/bigImg.42a4bd12.png";
              obj.code = value.code; // 商品编码
              obj.warehouse = value.warehouseName;
              obj.num = value.num ? value.num : 0;
              obj.minSaleNum = value.minSaleNum ? value.minSaleNum : 0;
              obj.saleNum = value.saleNum ? value.saleNum : 0;
              obj.vendibilityInventory = value.totalSaleSum
                ? value.totalSaleSum
                : 0;
              arr.push(obj);
            });
            this.loading = false;
            this.tableData = arr;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 点击搜索
    search() {
      this.form = this.formData;
      this.page = 1;
      this.getTableData();
    },
    // 清空表单
    resetForm(formName) {
      this.formData.codeName = ''
      this.$refs[formName].resetFields();
      this.search();
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.getTableData();
    },
    evil(fn) {
      let Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
      return new Fn("return " + fn)();
    }
  }
};
</script>

<style lang="scss" scoped>
.goods-inventory {
  width: 100%;
  height: 100%;
  .goods-inventory-main {
    .input-search {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      .el-select {
        margin-right: 16px;
      }
    }
    .el-button {
      letter-spacing: 1px;
    }
    .form {
      background: rgba(245, 247, 250, 1);
      padding: 16px;
      border-radius: 4px;
      margin-bottom: 24px;
      .btn {
        padding-left: 76px;
        display: flex;
        align-items: center;
        .el-button {
          width: 96px;
          margin: 0;
          margin-right: 16px;
        }
      }
    }
  }
  .replenishment {
    width: 14px;
    height: 14px;
  }
}
</style>
<style lang="scss">
.goods-inventory {
  .goods-inventory-main {
    .input-search {
      .el-select {
        .el-input__inner {
          width: 128px;
        }
      }
      .el-input {
        width: 320px;
      }
      .el-button {
        margin-left: 16px;
        width: 96px;
        letter-spacing: 1px;
      }
    }
    .table-img {
      .table_pagination {
        height: 56px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-pagination {
          height: 28px;
          padding: 0px;
          display: flex;
        }
      }
    }
  }
}
</style>
